import { format, parse } from "date-fns";
export function desdeMicrosiga(val){
    return format(parse(val, "yyyyMMdd", new Date()), "dd-MM-yyyy");
}



